import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { CITIES } from '@/data/cityContent';
import { track } from '@/lib/analytics';
import AmigosWordmark from './AmigosWordmark';

const Footer = () => {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div style={{ marginBottom: '1rem' }}>
              <AmigosWordmark size="lg" subline="tagline" testId="site-footer-wordmark" />
            </div>
            <p className="footer-desc">{t('footer.desc')}</p>
          </div>
          <div className="footer-col">
            <h4>{t('footer.nav')}</h4>
            <ul>
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/services">{t('nav.services')}</Link></li>
              <li><Link to="/areas">{t('nav.areas')}</Link></li>
              <li><Link to="/how-bail-works">{t('nav.how')}</Link></li>
              <li><Link to="/faq">{t('nav.faq')}</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t('footer.resources')}</h4>
            <ul>
              <li><Link to="/montgomery-county-jail">Montgomery County Jail</Link></li>
              <li><Link to="/financing">{lang === 'es' ? 'Financiamiento' : 'Financing & Payment Plans'}</Link></li>
              <li><Link to="/about">{lang === 'es' ? 'Sobre Nosotros' : 'About Amigos'}</Link></li>
              {CITIES.slice(0, 3).map((c) => (
                <li key={c.slug}><Link to={`/areas/${c.slug}`}>{c.en.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t('footer.contact')}</h4>
            <ul>
              <li>
                <a href="tel:9368282500" onClick={() => track('phone_click', { location: 'footer' })} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Phone size={14} /> (936) 828-2500
                </a>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: 6 }}><MapPin size={14} style={{ marginTop: 3, flexShrink: 0 }} /> Conroe, TX 77301 · Montgomery County</li>
              <li style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Clock size={14} /> 24/7 — {lang === 'es' ? 'Todos los días' : 'Every day'}</li>
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {year} Amigo&apos;s Bail Bonds. {t('footer.rights')} License #0111.</span>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Link to="/privacy-policy" data-testid="footer-privacy-link">{t('footer.privacy')}</Link>
            <Link to="/data-collection-policy" data-testid="footer-data-policy-link">{t('footer.dataPolicy')}</Link>
          </div>
          <span data-testid="footer-dev-credit">{t('footer.credit')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
